import { render, staticRenderFns } from "./settings_component.vue?vue&type=template&id=33879288&scoped=true&"
import script from "./settings_component.vue?vue&type=script&lang=js&"
export * from "./settings_component.vue?vue&type=script&lang=js&"
import style0 from "./settings_component.vue?vue&type=style&index=0&id=33879288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33879288",
  null
  
)

export default component.exports